//格式化日期
export function filterDate(date, sign = "-") {
    if (date instanceof Date) {
        let year = date.getFullYear(),
            month = date.getMonth() + 1,
            day = date.getDate();
        return (
            year +
            sign +
            (month < 10 ? "0" + month : month) +
            sign +
            (day < 10 ? "0" + day : day)
        );
    }
}

// 创建时间方法，兼容...
export function x3date(validDate) {
    if (!validDate) {
        return '';
    } else if (typeof validDate == 'string') {
        validDate = validDate.replace('T', ' ').replace(/-/g, '\/');
    }

    return new Date(validDate);
}


// 将字符串日期时间转化为Date类型
export function getDateTime(validDate) {
    if (!validDate) {
        return '';
    } else if (typeof validDate == 'string') {
        validDate = validDate.replace('T', ' ').replace(/-/g, '\/');
    }

    return new Date(validDate);
}

/**
 * 格式化date
 * @param validDate 任何可以new Date()的有效日期
 * @param fmt 形如 "yyyy-MM-dd hh:mm:ss", "MM月-dd日" 等字符串
 */
export function formatDatetime(validDate, fmt) {
    if (!validDate) {
        return '';
    } else if (typeof validDate == 'string') {
        validDate = validDate.replace('T', ' ').replace(/-/g, '\/');
    }

    let date = new Date(validDate);
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    return fmt;
}


function stringifyDate(datetime, type) {
    // let weekMap = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    let weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    datetime = new Date(datetime)
    let year = datetime.getFullYear()
    let simpleYear = datetime.getYear() - 100
    let month = datetime.getMonth() + 1
    month = month > 9 ? month : '0' + month
    let day = datetime.getDate()
    day = day > 9 ? day : '0' + day
    let hour = datetime.getHours()
    hour = hour > 9 ? hour : '0' + hour
    let min = datetime.getMinutes()
    min = min > 9 ? min : '0' + min
    let week = datetime.getDay()
    week = weekMap[week]
    let thatDay = (new Date(year, month - 1, day, 0, 0, 0)).getTime()

    if (type === 1) {
        return {
            withYear: `${year}-${month}-${day} ${hour}:${min}`,
            withMonth: `${month}-${day} ${hour}:${min}`,
            withDay: `${week} ${hour}:${min}`,
            withLastDay: `昨天 ${hour}:${min}`,
            withHour: `${hour}:${min}`,
            thatDay
        }

    } else if (type === 2) {
        return {
            withYear: `${day}/${month}/${simpleYear}`,
            withMonth: `${month}-${day}`,
            withDay: `${week}`,
            withLastDay: `昨天`,
            withHour: `${hour}:${min}`,
            thatDay
        }
    } else {
        return {
            withYear: `${year}年${month}月${day}日`,
            withMonth: `${month}月${day}日`,
            withDay: `${month}月${day}日`,
            withLastDay: `昨天`,
            withHour: `${hour}:${min}`,
            thatDay
        }
    }
}

/* 格式化日期 */
export function formatGoodDate(datetime, type) {
    let tempDate = (new Date()).getTime()
    let result = stringifyDate(datetime, type)
    let thatDay = result.thatDay
    let deltaTime = (tempDate - thatDay) / 1000

    if (deltaTime < 3600 * 24) {
        return result.withHour
    } else if (deltaTime < 3600 * 24 * 2) {
        return result.withLastDay
    } else if (deltaTime < 3600 * 24 * 7) {
        return result.withDay
    } else if (deltaTime < 3600 * 24 * 30) {
        return result.withMonth
    } else {
        return result.withYear
    }
}


export function getWeek(validDate, fmt) {
    if (typeof validDate == 'string') {
        validDate = validDate.replace('T', ' ').replace(/-/g, '\/');
    } else if (validDate == undefined) {
        return '';
    }
    let date = new Date(validDate);

    let arr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]

    return arr[date.getDay()]
}

// 获取当天延后 "num"天的日期
export function getDelayDay(day = 0, hour = 0) {
    let today = new Date();
    today = new Date(formatDatetime(today, 'yyyy/MM/dd'));
    return today.getTime() + day * 24 * 60 * 60 * 1000 + hour * 60 * 60 * 1000
}


/**
 * 获取以当前时间为基准，指定向前/或向后指定多少个时间单位 
 * 示例：
 * app.tool.date.getBasedOnToDayDate(-7) // 获取七天前的此时
 * app.tool.date.getBasedOnToDayDate(7) // 获取七天后的此时
 * app.tool.date.getBasedOnToDayDate(-1, 'Month') // 获取一个月前的此时
 * 
 * @param { Number } vals 具体多少个时间单位，几天/或几小时前用负数
 * @param { String } type 指定日期单位，默认Date(天)，可能值：Month(月)、Year(年)、Hours、Minutes、Seconds等
 * @param { Object Date } today 基准时间，默认当前时间
 * @returns Date
 */
export function getBasedOnToDayDate(vals, type = 'Date', today = new Date()) {
    try {
        if (!today['set' + type]) type = 'Date';
        today['set' + type](today['get' + type]() + vals);

        return new Date(today);
    } catch {
        return new Date();
    }
}

/**
 * 获取时间距离现在的表述
 * 刚刚：小于1分钟；
 * X分钟前：大于等于1分钟，小于1小时
 * X小时前：大于等于1小时，小于1天；
 * 2021.07.13 18:34 大于1天。
 * @param {Object Date} time 时间
 * @return { String}
 */

export function getPassTimeStr(time) {

	if (!time || ! new Date(time)) return '';
	let diffSeconds = (new Date() - new Date(time)) / 1000;
	if (diffSeconds <60) {
		return '刚刚';
	}
	let hourNum = 60 * 60;
	if (diffSeconds < hourNum) {
		return `${Math.floor(diffSeconds/60)}分钟前`;
	}
	let dayNum = 60 * 60 * 24;
	if (diffSeconds < dayNum) {
		return `${Math.floor(diffSeconds/(60 *60))}小时前`;
	}

	return formatDatetime(new Date(time), 'yyyy-MM-dd hh:mm');
    
}

// 时间段,少于一小时用分钟,否则用x小时y分钟表示
export function getDiffTimeDesc(start, end) {
    const startDate = new Date(`2000/01/01 ${start}`),
        endDate = new Date(`2000/01/01 ${end}`);
    let diffSeconds = (endDate.getTime() - startDate.getTime()) / 1000;
    let hourNum = 60 * 60;
    if (diffSeconds <= hourNum) {
        return `${Math.floor(diffSeconds / 60)}分钟`;
    }
    const minutes = diffSeconds % (60 * 60) === 0 ? '' : `${Math.floor(diffSeconds / 60) % 60}分钟`;
    return `${Math.floor(diffSeconds / (60 * 60))}小时${minutes}`;
}

export function diffByDay(time1, time2 = new Date()){
    const date1 = new Date(time1);
    const date2 = new Date(time2);
    date1.setHours(0);
    date1.setMinutes(0);
    date1.setSeconds(0);
    date1.setMilliseconds(0);
    date2.setHours(0);
    date2.setMinutes(0);
    date2.setSeconds(0);
    date2.setMilliseconds(0);
    return (date1.getTime() - date2.getTime()) / (24 * 60 * 60 * 1000);
}